var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Day',{attrs:{"day":"20.12.2017"}},[_c('div',{attrs:{"slot":"page-content"},slot:"page-content"},[_c('h2',[_vm._v("Bye bye, Brüssel!")]),_c('p',{staticClass:"center"},[_vm._v(" Aber nicht traurig sein, Jana! "),_c('br'),_vm._v(" Wir sehen uns nämlich schon ganz bald wieder! ♥ ")]),_c('hr'),_c('Gallery',{attrs:{"directory":"2017/20"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }